import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

const CampaignDescription = (props) => {
  return (
    <>
      <Modal
        show={props.showModalVisualization}
        onHide={() => props.setShowModalVisualization(false)}
        size="lg"
      >
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>{"Descripción de la campaña"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Col} className="mb-3">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="12" md="4">
                  Nombre de la campaña:
                </Form.Label>
                <Col sm="12" md="8">
                  <Form.Control
                    name="campaña"
                    type="text"
                    defaultValue={
                      props.viewItem ? props.viewItem.nombre_campaña : ""
                    }
                    className="rounded-pill"
                    readOnly
                  ></Form.Control>
                </Col>
              </Form.Group>
            </Form.Group>
            {props.userName ? (
              <Form.Group as={Col} className="mb-3">
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Segmento:
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      name="segmento"
                      type="text"
                      defaultValue={
                        props.viewItemComplete
                          ? props.viewItemComplete.segmento_list
                            ? props.viewItemComplete.segmento_list.nombre
                            : null
                          : null
                      }
                      className="rounded-pill"
                      readOnly
                    ></Form.Control>
                  </Col>
                </Form.Group>
              </Form.Group>
            ) : null}
            <Form.Group as={Col} className="mb-3">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="12" md="4">
                  Cuestionario:
                </Form.Label>
                <Col sm="12" md="8">
                  <Form.Control
                    name="cuestionario"
                    type="text"
                    defaultValue={
                      props.viewItem
                        ? props.viewItem.cuestionario_list
                          ? props.viewItem.cuestionario_list.nombre
                          : null
                        : null
                    }
                    className="rounded-pill"
                    readOnly
                  ></Form.Control>
                </Col>
              </Form.Group>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="12" md="4">
                  Tipo de herramienta:
                </Form.Label>
                <Col sm="12" md="8">
                  <Form.Control
                    name="tipo"
                    type="text"
                    defaultValue={
                      props.viewItem
                        ? props.viewItem.tipo_herramienta_list
                          ? props.viewItem.tipo_herramienta_list.nombre
                          : null
                        : null
                    }
                    className="rounded-pill"
                    readOnly
                  ></Form.Control>
                </Col>
              </Form.Group>
            </Form.Group>
            <Form.Group>
              <Form.Label className="ml-2">Responsables:</Form.Label>
              <Form.Control
                as="textarea"
                name="responsable"
                readOnly
                defaultValue={
                  props.viewItem
                    ? props.viewItem.responsable_list
                      ? props.viewItem.responsable_list.map((item) => {
                          return " " + item.first_name + " " + item.last_name;
                        })
                      : "No tiene"
                    : null
                }
                pattern="[A-Za-z0-9]+"
              ></Form.Control>
            </Form.Group>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Label className="ml-2">Fecha inicio:</Form.Label>
                <Form.Control
                  name="Inicio"
                  readOnly
                  type="text"
                  placeholder="Inicio"
                  pattern="[a-zA-Z][a-zA-Z\s]*"
                  className="rounded-pill"
                  defaultValue={
                    props.viewItem ? props.viewItem.fecha_inicio : null
                  }
                ></Form.Control>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label className="ml-2">Fecha fin</Form.Label>
                <Form.Control
                  name="fin"
                  className="rounded-pill"
                  readOnly
                  type="text"
                  pattern="[0-9]{13}"
                  defaultValue={
                    props.viewItem ? props.viewItem.fecha_fin : null
                  }
                  placeholder="fecha fin"
                ></Form.Control>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Label className="ml-2">Estado:</Form.Label>
                <Form.Control
                  name="Estado"
                  readOnly
                  type="text"
                  placeholder="Estado"
                  pattern="[a-zA-Z][a-zA-Z\s]*"
                  className="rounded-pill"
                  defaultValue={
                    props.viewItem
                      ? props.viewItem.activa === true
                        ? "Activa"
                        : "Inactiva"
                      : null
                  }
                ></Form.Control>
              </Form.Group>
              <Form.Group as={Col}></Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => props.setShowModalVisualization(false)}
            >
              Cerrar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default CampaignDescription;
